export default {
  created() {
    this.$bus.$on('global-dismiss-modal', this.showElement);
  },

  beforeDestroy() {
    this.$bus.$off('global-dismiss-modal', this.showElement);
  },

  methods: {
    showElement() {
      this.ui.showElement = false;
    },
  },
};
